/**
 * 高级设置-任务设置
 * @author ariel
 * @date 2020-12-09
 */
import React from "react";
import {component_tool,utils_tool, framework_tool} from '@/tool';
import { WizTableForm } from '@/containers/common'

import './index.less'
import moment from "moment";

const {WizCard,WizSelect, WizComponent, WizForm, Wizmessage,WizButton, WizTabs, WizCollapse, WizRow, WizCol, WizCheckbox, WizIcon, WizRadio, WizInput, WizDatePicker, WizInputNumber,WizTooltip} = component_tool
const {WizAvatarUpload, modelUtils} = framework_tool
const { TextArea } = WizInput;
let { Storage } = utils_tool
const { Option, OptGroup } = WizSelect
const _getValue = (type, key) => {
  const values = {
    sendType: {
      '0': '站内通知',
      '1': '推送消息',
      '3': '短信通知',
      '4': '邮件通知',
      // '5': '企业微信',
      '6': '智能电话',
    },
    sendTypeIcon: {
      '0': 'cloud-server',
      '1': 'mobile',
      '3': 'message',
      '4': 'mail',
      // '5': 'wechat',
      '6': 'phone',
    },
  }
  return values[type][key] || ''
}

export default class WizTaskSet extends WizComponent {
  constructor(props) {
    super(props);
    let use = Storage.getStorage('user') || {}
    //是否禁用编辑权限
    this.flag = true
    if (use && use.personId === '1cdf270fdc764dfb91634d3b2f48257f') {
      this.flag = false;
    }
    let cloneObj = this._cloneProps(props.taskNoticeData,props.labelInfo,props.taskNoticeIds)
    this.state = {
      ...cloneObj,
      //taskNoticeIds: [],
      phoneCodeVisible: false,//是否显示语音通话模版信息
      //labelInfo: props?.labelInfo || [],   //app信息
      currentPhoneCode: '',//当前编辑的语音模版编码code
      currentSceneIndex: -1,
      initNow: new Date().getTime(),
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props && (nextProps.initNow !=this.props.initNow
       || nextProps.taskNoticeIds.join(',') !=this.props.taskNoticeIds.join(','))) {
      let cloneObj = this._cloneProps(nextProps.taskNoticeData,nextProps.labelInfo,nextProps.taskNoticeIds)
      this.setState({...cloneObj})
    }
  }
  _getTimeNum(startDate, endDate) {
    let stime = new Date(startDate).getTime();
    let etime = new Date(endDate).getTime();
    let usedTime = etime - stime;  //两个时间戳相差的毫秒数
    let days = Math.floor(usedTime / (24 * 3600 * 1000));
    //计算出小时数
    let leave1 = usedTime % (24 * 3600 * 1000);    //计算天数后剩余的毫秒数
    let hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数
    let leave2 = leave1 % (3600 * 1000);        //计算小时数后剩余的毫秒数
    let minutes = Math.floor(leave2 / (60 * 1000));
    let hoursNum = days * 24 + hours + minutes / 60
    return hoursNum;
  }

  _onTaskSubmit(values) {
    let {submit, record} = this.props;
    let coverImg = values['coverImg']
    if (coverImg && coverImg.length) {
      values['img'] = coverImg[0]['fileId']
      delete values['coverImg']
    }
    values['startDate'] = moment(values['startDate'] || record['startDate']).format("YYYY-MM-DD HH:mm:ss")
    values['endDate'] = moment(values['endDate'] || record['endDate']).format("YYYY-MM-DD HH:mm:ss")

    values['status'] =values['status'] || record['status']
    values['status'] = values['status'] && values['status'] > 0 ? 1 : 0

    let timeNum = this._getTimeNum(record['startDate'], record['endDate'])

    let {
      taskNoticeIdList,labelInfo,taskNoticeIds
    } = this.state

    values['taskNoticeIds'] = taskNoticeIds
    let templateList = []
    let errorMsg = ''
    if (taskNoticeIdList && taskNoticeIdList instanceof Array && taskNoticeIdList.length > 0) {
      taskNoticeIdList?.forEach((element,index) => {
        let intervalNum;
        if(this.state?.['intervalNumChecked'+index]){
          if(!element.intervalNum){
            errorMsg =`【${element?.sceneName}】请输入间隔时间`
          }
          intervalNum = element.intervalNum
        }else{
          intervalNum = null
        }
        element['intervalNum'] = intervalNum
        let assignTime;

        if(this.state?.['assignTimeChecked'+index]){
          if(!element.assignTime){
            errorMsg = `【${element?.sceneName}】请输入指定时间`
          }
          assignTime = element.assignTime
        }else{
          assignTime = null
        }
        element['assignTime'] = assignTime
        element?.sceneInfoList?.forEach(sceneInfo => {
          let infoState = taskNoticeIds.includes(sceneInfo.id) ? 1 : 0
          if(infoState && sceneInfo.sendType==5 && !sceneInfo?.appIds?.length){
            errorMsg=element?.sceneName+'【企业微信通知】已选择,应用不能为空'
          }
          if(infoState){
          let template = {
            noticeWhitelist: element?.noticeWhitelist, state: infoState,intervalNum,assignTime,
            content: sceneInfo.content, sendType: sceneInfo.sendType, id: sceneInfo.id, appIds: sceneInfo.appIds
          }
          if (sceneInfo.code != null && sceneInfo != undefined) {
            template = { ...template, code: sceneInfo.code }
          }
          templateList.push({ ...template })
        }
        })
      });
      values['templateList'] = templateList
    }
    if(errorMsg){
      wizNotice.error(errorMsg)
      return false
    }
    if (taskNoticeIdList?.[0]?.sceneInfoList?.some(p=>taskNoticeIds.includes(p.id))) {
      let intervalNum = taskNoticeIdList[0]['intervalNum']
      let assignTime = taskNoticeIdList[0]['assignTime']
      if ((intervalNum && assignTime && (intervalNum != null && assignTime != null)) || (!intervalNum && !assignTime)) {
        wizNotice.error("任务开始前:间隔时间与指定时间择一输入")
        return false
      } else if (assignTime && assignTime > values['startDate']) {
        wizNotice.error('任务开始前:指定时间不在任务开始时间前')
        return false
      } else if (intervalNum && intervalNum > timeNum) {
        wizNotice.error('任务开始前:间隔时间数字不能大于任务间隔时间')
        return false
      }
    }

    if (taskNoticeIdList?.[1]?.sceneInfoList?.some(p=>taskNoticeIds.includes(p.id))) {
      let intervalNum = taskNoticeIdList[1]['intervalNum']
      let assignTime = taskNoticeIdList[1]['assignTime']
      if ((intervalNum && assignTime && (intervalNum != null && assignTime != null)) || (!intervalNum && !assignTime)) {
        wizNotice.error("任务进行中:间隔时间与指定时间择一输入")
        return false
      } else if (assignTime && (assignTime < values['startDate'] || assignTime > values['endDate'])) {
        wizNotice.error('任务进行中:指定时间不在任务进行中')
        return false
      } else if (intervalNum && intervalNum > timeNum) {
        wizNotice.error('任务进行中:间隔时间数字不能大于任务间隔时间')
        return false
      }
    }

    if (taskNoticeIdList?.[2]?.sceneInfoList?.some(p=>taskNoticeIds.includes(p.id))) {
      let intervalNum = taskNoticeIdList[2]['intervalNum']
      let assignTime = taskNoticeIdList[2]['assignTime']
      if ((intervalNum && assignTime&& (intervalNum != null && assignTime!= null)) || (!intervalNum && !assignTime)) {
        wizNotice.error("任务结束前:间隔时间与指定时间择一输入")
        return false
      } else if (assignTime && assignTime> values['endDate']) {
        wizNotice.error('任务结束前:指定时间不在任务结束时间前')
        return false
      } else if (intervalNum && intervalNum > timeNum) {
        wizNotice.error('任务结束前:间隔时间数字不能大于任务间隔时间')
        return false
      }
    }

   submit(values)
  }

  _getNoticeIds(taskNoticeIds, checkedValues, info, sceneName) {
    if (checkedValues instanceof Array) {
      if (checkedValues.length > 0) {
        taskNoticeIds.push(...checkedValues)
      } else {
        taskNoticeIds.splice(taskNoticeIds.findIndex(item => item === sceneName + '_' + info.id), 1)
      }
    }
    this.setState({taskNoticeIds: taskNoticeIds})
  }

  _noticeOnChange(commentName, e) {
    if (commentName) {
      this.setState({
        [commentName]: e.target.value
      })
    }
  }
  _appOnChange(commentName, e) {
    if (commentName) {
      this.setState({
        [commentName]: e
      })
    }
  }
/**
   * 通知内容
   * @param {通知内容} content
   * @param {选择的应用id} appIds
   * @param {应用选项信息} appLabel
   * @param {是否正在编辑} asEdit
   * @param {是否勾选} disabled
   * @param {通知内容的key} contentKey
   * @param {通知选择应用的key} appIdsKey
   * @param {是否为语音通知} isPhone
   * @param {是否为企业微信推送} isWechat
   * @param {点击编辑时触发的函数} editFunc
   * @param {点击保存时触发的函数} saveFunc
   * @returns
   */
 _getContentInfo = (content = '', appIds = [], appLabel = [], asEdit = false, disabled = false, contentKey = '', isPhone = false, isWechat = false,
 editFunc = () => { }, saveFunc = () => { }, appSaveFunc = () => { }) => {
 let colspan = asEdit&&!isPhone ? 21 : 24

 const appOption = appLabel.map(app =>

  <OptGroup key={'optGroup_taskSet_'+contentKey} label={app['labelName']}>
    {app.optionList && app.optionList instanceof Array && app.optionList.length > 0 ?
      app.optionList.map(option =>
        <Option key={'option_taskSet_'+contentKey+'_'+option.optionValue } value={option.optionValue}>{option.optionName}</Option>)
      : null
    }
  </OptGroup>)
 return (
   <WizRow>
     <WizCol span={colspan} style={{ textAlign: 'left' }}>
       {asEdit && !isPhone ?
         <TextArea ref={contentKey} key={contentKey}
           value={this.state[contentKey]}
           maxLength={500} rows={4}
           placeholder="请输入通知内容"
           onChange={this._noticeOnChange.bind(this, contentKey)} />
         :
         <div>
           {isWechat ?
           <>
             <div className="apply-notice-value" >
               <div className="apply-notice-value__app">选择应用：</div>
               <WizSelect style={{ width: '100%', "minWidth": '72px', "paddingRight": '7px' }}
                 placeholder="请选择应用"
                 allowClear={true}
                 required={true}
                 disabled={disabled}
                 defaultValue={appIds}
                 mode="multiple"
                 onChange={appSaveFunc.bind(this)}
               >
                 {appOption}
               </WizSelect>
             </div>
             </>
             : <></>}
           <div className="apply-notice-value" >
             <div className="apply-notice-value__title">通知内容：</div>
             {content != '' && content !== undefined ?
               <div className="apply-notice-value__value" onClick={editFunc}>
                 <p>{content}</p>
               </div>
               : <div className="apply-notice-value__title">暂无</div>
             }
           </div>
         </div>
       }
     </WizCol>
     {asEdit&&!isPhone ?
       <WizCol span={3} style={{ textAlign: 'right' }}>
         <WizButton type="primary" onClick={saveFunc}>保存</WizButton>
       </WizCol>
       : <></>
     }
   </WizRow>
 )
}
  /**
   * 构建通知方式
   * @param {当前通知方式内容} list
   * @param {当前通知模式的index} currentSceneIndex
   * @param {应用选项} appLabel
   * @returns
   */
  _getContentList(list, currentSceneIndex, appLabel =[]) {
    let {taskNoticeIdList,taskNoticeIds} = this.state
    let activeKeys = []
    list.forEach((info) => {
      activeKeys.push(info.sendType)
    })
    // 默认展开数据
    let defaultActiveKey = list.filter(item => item.state == 1).map(item => item.sendType)|| []

    let defaultValue =  taskNoticeIds || []
    let r = []
    list.forEach((info,index) => {
    let isPhone = info['sendType'] === 6
    let isWechat = info['sendType'] === 5
    // 判断通知方式是否勾选到
    let disabled = !defaultValue.includes(info.id)
    let contentKey = currentSceneIndex + '@comment@' + index


    let saveFuc = () => {
      //保存taskNoticeIdList的值
      let comment = this.state[currentSceneIndex + '@comment@' + index]
      let code = this.state[currentSceneIndex + '@code@' + index]
      let appIds = this.state[currentSceneIndex + '@appIds@' + index]
      taskNoticeIdList[currentSceneIndex]['sceneInfoList'][index]['content'] = comment
      taskNoticeIdList[currentSceneIndex]['sceneInfoList'][index]['code'] = code
      taskNoticeIdList[currentSceneIndex]['sceneInfoList'][index]['appIds'] = appIds
      this.setState({
        [currentSceneIndex + '@Group@' + index]: 0,
      }, () => {
      })
    }
    let editFuc = disabled&&this.flag ? null : () => {
      this.setState({
        [currentSceneIndex + '@Group@' + index]: 1,
        [currentSceneIndex + '@comment@' + index]: info['content'],
        [currentSceneIndex + '@code@' + index]: info['code'],
        [currentSceneIndex + '@appIds@' + index]: info['appIds'],
        currentPhoneCode: info['code'],
        currentSceneIndex: currentSceneIndex,
        index: index,
        phoneCodeVisible: isPhone ? true : false
      }, () => {
      })
    }

    let appSaveFunc = (appIds) => {

      //保存taskNoticeIdList的值
      taskNoticeIdList[currentSceneIndex]['sceneInfoList'][index]['appIds'] = appIds
      this.setState({
        [currentSceneIndex + '@appIds@' + index]: appIds
      }, () => {
      })
    }

      r.push(
        <WizCollapse key ={currentSceneIndex+'@'+info.sendType} defaultActiveKey={defaultActiveKey} className='taskSet collapse_content'>
          <WizCollapse.Panel
            key={info.sendType}
            header={
              <WizRow>
                <WizCol>
                  <WizCheckbox.Group
                    key={info.sendType}
                    options={[
                      {
                        label: <>
                          <WizIcon type={_getValue('sendTypeIcon', info.sendType)}/>
                          {_getValue('sendType', info.sendType)}
                        </>,
                        value: info.id
                      }
                    ]}
                    defaultValue={defaultValue}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onChange={(checkedValues) => {
                    let { taskNoticeIds } = this.state
                    if (checkedValues instanceof Array) {
                      if (checkedValues.length > 0) {
                        taskNoticeIds.push(...checkedValues)
                      } else {
                        taskNoticeIds.splice(taskNoticeIds.findIndex(item => item === info.id), 1)
                      }
                    }
                //这里需要set一个值，不然state不会检测到发生变化
                this.setState({ taskNoticeIds, taskNoticeIdsJoin: taskNoticeIds.join(",") })
                    }}
                  />
                </WizCol>
              </WizRow>
            }
          >

            {this._getContentInfo(info['content'], info['appIds'], appLabel,
              this.state[currentSceneIndex + '@Group@' + index], disabled, contentKey,
              isPhone, isWechat,
              editFuc, saveFuc, appSaveFunc)}

          </WizCollapse.Panel>
        </WizCollapse>
      )
    })
    return (
      <WizRow>
        <WizCol span={4}>通知方式:</WizCol>
        <WizCol span={19}>
          {r}
        </WizCol>
      </WizRow>
    )
  }

  _time(time = +new Date()) {
    let date = new Date(time + 8 * 3600 * 1000); // 增加8小时
    return date.toJSON().substr(0, 19).replace('T', ' ');
  }

  _cloneProps = (taskNoticeIdList,labelInfo,taskNoticeIds) => {

    let copyRecord = []
    let noticeTimeInfo = {}
    if (taskNoticeIdList && taskNoticeIdList instanceof Array && taskNoticeIdList.length > 0) {
      taskNoticeIdList.forEach((data,index) => {
        let { sceneInfoList, ...other } = data
        let copySceneInfoList = []
        if (sceneInfoList && sceneInfoList instanceof Array && sceneInfoList.length > 0) {
          sceneInfoList.forEach(scenenInfo => {
            copySceneInfoList.push({ ...scenenInfo })
          })
        }
        let intervalNumChecked = false;
        let assignTimeChecked = false;
        if (data.intervalNum) {
          intervalNumChecked = true
        } else if (data.assignTime) {
          assignTimeChecked = true
        }
        noticeTimeInfo = {['intervalNumChecked'+index]:intervalNumChecked,
        ['assignTimeChecked'+index]:assignTimeChecked,
        ...noticeTimeInfo}
        copyRecord.push(Object.assign({}, { ...other,intervalNumChecked,assignTimeChecked, sceneInfoList: copySceneInfoList }))

      });
    }
    let copyLabelInfo =Object.assign([], labelInfo)
    let copyTaskNoticeIds =Object.assign([], taskNoticeIds)
    return {taskNoticeIdList:copyRecord,labelInfo:copyLabelInfo,taskNoticeIds:copyTaskNoticeIds,...noticeTimeInfo}
  }
  _getNoticeInfo(form, taskNoticeIds,taskNoticeIdList) {
    // let {taskNoticeData} = this.props
    let { labelInfo,initNow } = this.state
    let recordInfo = Object.assign([], taskNoticeIdList)
    //测试用代码
    // let recordInfo = []
    // if(taskNoticeIdList?.length>1){

    //   recordInfo.push(taskNoticeIdList[0])
    // }
    let contentList = []
    let appLabel = labelInfo || []

    recordInfo && recordInfo.length && recordInfo.forEach((data,index) => {
      let sceneName = index

      let intervalNumChecked = this.state['intervalNumChecked' + index],
        assignTimeChecked = this.state['assignTimeChecked' + index]
      init = false

      contentList.push(
        <WizTabs.TabPane tab={data.sceneName} key={initNow + '_' + index}>
          <WizRow className='taskSet notice_set_row'>
            <WizCol span={1}><WizIcon type="question-circle"/></WizCol>
            <WizCol span={22}>{data.description}</WizCol>
          </WizRow>
          {this._getContentList(data.sceneInfoList, index, appLabel)}
          <WizRow className='taskSet notice_set_row'>
            <WizCol span={4}>通知时间:</WizCol>
            <WizCol span={19}>
              <WizRow className='taskSet notice_set_row'>
                <WizCol span={5}><WizRadio
                  checked={intervalNumChecked}
                  onChange={(e) => {
                    //如果勾选了通知时间
                    if(e?.target?.checked){
                      this.setState({
                        ['intervalNumChecked' + sceneName]: true,
                        ['assignTimeChecked' + sceneName]: false
                      }, () => {
                      })
                    }
                  }}
                >间隔时间</WizRadio></WizCol>
                <WizCol span={10}>
                  <WizInputNumber disabled={!intervalNumChecked} placeholder='请输入间隔时间' min={0.5}
                                  defaultValue={data['intervalNum'] || null}
                                  onChange={(value) => {
                                    this.state['taskNoticeIdList'][index]['intervalNum']  = value
                                    this.setState({
                                      ['intervalNum_' + index]: value,
                                      ['assignTime_' + index]: undefined
                                    }, () => {
                                    })
                                  }
                                  }
                  />
                </WizCol>
                <WizCol span={1} push={1}>h</WizCol>
              </WizRow>
              <WizRow>
                <WizCol span={5}><WizRadio
                  checked={assignTimeChecked}
                  onChange={(e) => {
                    //如果勾选了指定时间
                    if(e?.target?.checked){
                      this.setState({
                        ['intervalNumChecked' + sceneName]: false,
                        ['assignTimeChecked' + sceneName]: true
                      }, () => {
                      })
                    }
                  }}
                >指定时间</WizRadio></WizCol>
                <WizCol span={10}>
                  <WizDatePicker disabled={!assignTimeChecked} placeholder='请选择时间' showTime={true}
                                 format='YYYY-MM-DD HH:mm:ss'
                                 defaultValue={data['assignTime']?moment(data['assignTime']) : null}
                                 onChange={(value) => {
                                  this.state['taskNoticeIdList'][index]['assignTime']  = this._time(value)
                                  this.setState({
                                    ['assignTime_' + index]: this._time(value),
                                    ['intervalNum_' + index]: undefined
                                  }, () => {
                                  })
                                 }
                                 }
                  />
                </WizCol>
              </WizRow>
            </WizCol>
          </WizRow>
          <WizRow>
            <WizCol span={4}>是否通知白名单:</WizCol>
            <WizCol span={19}>
              <WizRadio.Group
                key={index}
                options={[{label: '是', value: 1}, {label: '否', value: 0}]}
                defaultValue={data['noticeWhitelist'] || 0}
                onChange={(e) => {

                  this.state['taskNoticeIdList'][index]['noticeWhitelist']  = e.target.value
                  this.setState({
                    ['noticeWhitelist_' + index]: e.target.value
                  }, () => {
                  })
                }}
              />
            </WizCol>
          </WizRow>
        </WizTabs.TabPane>
      )
    })
    contentList = contentList.sort((a, b) => {
      return a.key - b.key
    });
    return (
      <WizTabs onChange={this.changeTab}>
        {contentList}
      </WizTabs>
    )
  }

  _tableCancel = (obj, e) => {
    this.setState({
      phoneCodeVisible: false,
    });
  }
  _tableSubmit = (obj, e) => {
    let { currentSceneIndex, taskNoticeIdList, index } = this.state
    if (obj['value'] && obj['valueRows'] instanceof Array && obj['valueRows'].length > 0) {
      if (taskNoticeIdList?.[currentSceneIndex]?.['sceneInfoList']?.[index]) {
        taskNoticeIdList[currentSceneIndex]['sceneInfoList'][index]['code'] = obj['valueRows'][0]['code']
        taskNoticeIdList[currentSceneIndex]['sceneInfoList'][index]['content'] = obj['valueRows'][0]['content']
        taskNoticeIdList[currentSceneIndex]['sceneInfoList'][index]['appIds'] = obj['valueRows'][0]['appIds']
      }
    }
    this.setState({
      phoneCodeVisible: false
    });
  }

  _renderBtn = (value, valueRows) => {
    return (
      <></>
    )
  }
  render() {
    let {record, urlType,   taskNoticeData,labelInfo} = this.props
    let {taskNoticeIdList,currentPhoneCode,phoneCodeVisible,taskNoticeIds} = this.state
    //this.setState({taskNoticeIds: taskNoticeIds})
    let taskColumns = []
    taskColumns = taskColumns.concat([
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: record && record.id
        }
      },
      {
        title: '任务信息设置',
        name: 'task-line-transfer',
        formItem: {
          type: 'line',
          orientation: "left",
          style: {color: 'black', fontSize: 16}
        },
      },
      {
        title: '任务名称',
        name: 'name',
        formItem: {
          initialValue: record && record.name,
          rules: [
            {
              required: true,
              message: '任务名称必填',
            }
          ],
          maxLength: 20,
        },
      },
      {
        title: '开始时间',
        name: 'startDate',
        formItem: {
          initialValue: record && record.startDate,
          type: 'date',
          rules: [
            {
              required: true,
              message: '开始时间必填'
            }
          ],
          format: 'YYYY-MM-DD HH:mm:ss',
          showTime: {
            format: 'HH:mm:ss'
          }
        }
      },
      {
        title: '结束时间',
        name: 'endDate',
        formItem: {
          initialValue: record && record.endDate,
          type: 'date',
          rules: [
            {
              required: true,
              message: '结束时间必填'
            }
          ],
          format: 'YYYY-MM-DD HH:mm:ss',
          showTime: {
            format: 'HH:mm:ss'
          }
        }
      },
      {
        title: <span>
        封面&nbsp;
        <WizTooltip title="请上传大小不超过2MB,图片尺寸建议400*207">
            <WizIcon type="question-circle-o" />
        </WizTooltip>
      </span>,
        name: 'img',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            let {img} = this.props && this.props.record
            const {getFieldDecorator} = form
            return (
              <>
                {getFieldDecorator('coverImg', {
                  initialValue: (img) ? [
                    {fileId: img}
                  ] : [],
                })(
                  <WizAvatarUpload
                    key={record && record.img || ''}
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 207}
                    beforeUpload={(file) => {
                      let result = true;
                      const isLt1M = file.size / 1024 / 1024 < 2;
                      if (file.type.indexOf('image/') == -1) {
                        Wizmessage.error('只能上传图片类型,请重新选择!');
                        result = false;
                      } else if (!isLt1M) {
                        Wizmessage.error('图片不得超过2MB!');
                        result = false;
                      }
                      return result;
                    }}
                  />
                )}
              </>
            )
          }
        }
      },
      {
        title: "重要程度",
        name: "importance",
        formItem: {
          type: 'radio',
          initialValue: record && record.importance ? record.importance : 0
        },
        dict: [
          {code: 0, codeName: "重要"},
          {code: 1, codeName: "一般"},
        ],
      },
    ])

    if (record && record.bizId) {
      taskColumns = taskColumns.concat([
        {
          title: '启用',
          name: 'status',
          formItem: {
            type: 'checkbox',
            initialValue: record && record.status ? [record.status] : [0]
          },
          dict: [
            {code: 1}
          ]
        }
      ])
    }

    taskColumns = taskColumns.concat([
      {
        title: '消息通知设置',
        name: 'msg-line-transfer',
        formItem: {
          orientation: "left",
          type: 'line',
          style: {color: 'black', fontSize: 16, marginTop: 10}
        },
      },
    ])

    let taskNoticeColumns = []
    taskNoticeColumns = taskNoticeColumns.concat([
      {
        title: '消息通知',
        name: 'needNotice',
        formItem: {
          type: 'radio',
          initialValue: record && record.needNotice ? record.needNotice : 0
        },
        dict: [
          {code: 1, codeName: '是'},
          {code: 0, codeName: '否'}
        ]
      },
      {
        title: '通知模式',
        name: 'taskNoticeInfo',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            return (
              <>
                {this._getNoticeInfo(form, taskNoticeIds, taskNoticeIdList)}
              </>
            )
          }
        }
      }
    ])

    taskColumns = taskColumns.concat(taskNoticeColumns)

    let onTaskSubmit = this._onTaskSubmit.bind(this)

    let _columns = [];
    if (urlType && urlType === 'TASK') {
      _columns = taskNoticeColumns
    } else {
      _columns = taskColumns
    }

    let taskFormProps = {
      ref: 'form',
      columns: _columns,
      onSubmit: onTaskSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }
    let initialValue = [currentPhoneCode]
    let initRows = [{ code: currentPhoneCode }]
    const voiceMsgConfig = WizTableForm.Config.voiceMsg(this, { apiParams: {} })
    return (
      <div className='taskSet'>
        <WizForm {...taskFormProps} onReset={() => {
          let cloneObj = this._cloneProps(taskNoticeData,labelInfo,this.props.taskNoticeIds)
          this.setState({
            ...cloneObj,
            phoneCodeVisible: false,//是否显示语音通话模版信息
            currentPhoneCode: '',//当前编辑的语音模版编码code
            currentSceneIndex: -1,
            initNow: new Date().getTime(),
          })

        }}/>

        <WizTableForm key={currentPhoneCode} {...voiceMsgConfig} showModal={true} visible={phoneCodeVisible}
          selectType={'radio'} value={initialValue} initRows={initRows}
          onSubmit={this._tableSubmit}
          renderValue={this._renderBtn}
          onCancel={this._tableCancel}
        />
      </div>
    )
  }

}


WizTaskSet.defaultProps = {}

WizTaskSet.propTypes = {}
